import { CircularProgress, Dialog, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiPaper-root': {
		width: '100%',
		maxWidth: '584px',
		margin: 16,
		padding: '16px',
		boxSizing: 'border-box',
		borderRadius: 8,
		alignItems: 'center',
		background: theme.palette.neutral[0],
	},
}));

export const StyledLoader = styled(CircularProgress)(({ theme }) => ({
	color: theme.palette.primary.light,
}));
